<!--同业合同审核-->
<template>
  <Page class="queryView">
    <template v-slot:contentTop>
      <div class="queryView-conditions with-btn-end">
        <a-form layout="inline" :form="form">
          <a-form-item label="合同名称">
            <a-input v-decorator="['contractName']" placeholder="请输入合同名称"></a-input>
          </a-form-item>
          <a-form-item label="合同类型">
            <a-select
              class="form-control"
              :options="typesMap.contractType"
              v-decorator="['contractType']"
              placeholder="请选择"
              showSearch
              :filterOption="filterByPY$t"
            ></a-select>
          </a-form-item>
          <a-form-item label="合同状态">
            <a-select
              class="form-control"
              :options="typesMap.contractStatusList"
              v-decorator="['contractStatus']"
              placeholder="请选择"
              showSearch
              :filterOption="filterByPY$t"
            ></a-select>
          </a-form-item>
        </a-form>
        <div class="condition-btns">
          <a-button class="app-btn" type="default" @click="resetAndQuery$qv">重置搜索</a-button>
          <a-button class="app-btn" type="primary" @click="doQuery(1)">立即搜索</a-button>
          <!-- <a-button class="app-btn" type="primary" @click="test(1)">???</a-button> -->
        </div>
      </div>
    </template>
    <div>
      <div class="pageContent-title">合同列表</div>
      <div class="queryView-main">
        <a-table
          class="mt-5"
          rowKey="columnId"
          bordered
          :loading="tableLoading"
          :columns="tableColumns"
          :dataSource="dataSource"
          @change="handleTableChange$qv"
          :pagination="{
            current: pageNumber,
            pageSize: pageSize,
            total: countTotal,
            showSizeChanger: true,
            showQuickJumper: true,
          }"
        >
          <!-- 操作列 -->
          <template slot="handler" slot-scope="text, row">
            <div class="flex gap-5 justify-center text-primary-500">
              <span type="icon-chakan" class="cursor-pointer" @click="checkRow(row)">查看</span>
            </div>
          </template>
        </a-table>
      </div>
    </div>
  </Page>
</template>

<script>
import Page from '@/components/Page'
import { queryViewMixin, toolMixin } from '@/utils/mixin'
export default {
  mixins: [queryViewMixin, toolMixin],
  data() {
    const tableColumns = [
      {
        title: '序号',
        width: '60px',
        align: 'center',
        customRender: (text, row, index) => {
          return <span> {this.pageSize * (this.pageNumber - 1) + (index + 1)} </span>
        },
      },
      {
        title: '合同类型',
        align: 'center',
        dataIndex: 'contractType',
        customRender: text => {
          console.log('text', text)
          return <div>{text == 'COMPANY' ? '旅行合同' : '劳务合同'}</div> 
        },
      },
      {
        title: '合同名称',
        align: 'center',
        dataIndex: 'contractName',
      },
      {
        title: '甲方',
        align: 'center',
        dataIndex: 'phone',
      },
      {
        title: '乙方',
        align: 'center',
        dataIndex: 'phone',
      },
      {
        title: '签署日期',
        align: 'center',
        dataIndex: 'createTime',
      },
      {
        title: '签署有效期',
        align: 'center',
        dataIndex: 'createTime',
      },
      // {
      //   title: '绑定供应商账号',
      //   width: '15%',
      //   align: 'center',
      //   dataIndex: 'parentNickname',
      //   customRender: (text, row, index) => {
      //     return (
      //       <div>
      //         {!text && (
      //           <a
      //             onclick={() => {
      //               this.openModal(text, row)
      //             }}
      //           >
      //             去绑定
      //           </a>
      //         )}
      //         {text && <span>{text}</span>}
      //       </div>
      //     )
      //   },
      // },
      {
        title: '合同状态',
        align: 'center',
        dataIndex: 'contractStatus',
        customRender: (text, row, index) => {
          return (
            <div>
              <span>{this.translateType$t(text, 'contractStatusList')}</span>
            </div>
          )
        },
      },
      {
        title: '操作',
        align: 'center',
        dataIndex: 'detail',
        scopedSlots: {
          customRender: 'handler',
        },
      },
    ]
    return {
      form: this.$form.createForm(this),
      pageNumber: 1,
      pageSize: 10,
      countTotal: 0,
      tableLoading: false,
      tableColumns: tableColumns,
      dataSource: [],
    }
  },
  components: {
    Page,
  },
  computed: {
    typesMap() {
      return {
        contractStatusList: [
          { value: 1, label: '未签署' },
          { value: 2, label: '签署中' },
          { value: 3, label: '已完成' },
        ],
        contractType: [
          { value: '1', label: '旅游合同' },
          { value: '2', label: '入职合同' },
        ],
      }
    },
  },
  mounted() {
    // this.doQuery()
  },
  methods: {
    doQuery() {
      // this.$axios
      //   .get(`/user/admin/agent`, {
      //     params: {
      //       ...this.form.getFieldsValue(),
      //       page: this.pageNumber,
      //       limit: this.pageSize,
      //     },
      //   })
      //   .then(res => {
      //     this.countTotal = Number(res.count)
      //     this.dataSource = res.data
      //   })
    },
    checkRow(row) {
      console.log(row)
      if (!row.id) {
        return
      }
      this.$router.push({
        path: '/m/scopeMain/contract/contractDetail',
        query: {
          contractId: row.contractId,
        },
      })
    },
  },
}
</script>

<style lang="less"></style>
